const axios = require("axios");
import config from "@/http/config";
import router from "@/router/router";
import NProgress from "nprogress";
import { MessageBox } from "element-ui";
import Message from "@/utils/message";
import "nprogress/nprogress.css";
import i18n from "../utils/i18n";
const cookie = require("js-cookie");

let count = true;
NProgress.configure({ showSpinner: false });
axios.defaults.withCredentials = true;

const instance = axios.create({
  baseURL: config.baseUrl,
  headers: {
    appId: "123456789"
  },
  timeout: config.timeout,
  transformResponse: [
    function (data) {
      return data;
    }
  ]
});

instance.interceptors.request.use(
  config => {
    NProgress.start();
    let token = cookie.get("token");
    if (token && config.url !== "login") {
      config.headers.token = token;
    } else {
      if ("/login" !== router.history.current.path) {
        router.push("/login");
      }
      NProgress.done();
    }
    return config;
  },
  error => {
    const errorInfo = error.response;
    if (errorInfo) {
      const errorStatus = errorInfo.status;
      router.push({
        path: `/error/${errorStatus}`
      });
    }
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => {
    let result;
    if (response.request.responseType === "blob") {
      result = response;
    } else {
      if (response.data) {
        result = JSON.parse(response.data);
      } else {
        let res = response.request.responseText;
        if (res && res !== "") {
          result = JSON.parse(response.request.responseText);
        }
      }
    }

    switch (result.code) {
      case -1:
        Message.warning({
          message: result.msg,
          duration: 2000,
          showClose: false
        });
        break;
      case 2:
        Message.warning({
          message: result.msg,
          duration: 2000,
          showClose: false
        });
        break;
      case 0:
        break;
      case 401:
        Message.warning({
          message: result.msg,
          duration: 2000,
          showClose: false
        });
        break;
      case 403:
        NProgress.done();
        if ("/login" !== router.history.current.path) {
          if (count) {
            count = false;
            MessageBox.confirm(result.msg, i18n.t("common.tip"), {
              confirmButtonText: i18n.t("common.definite"),
              cancelButtonText: i18n.t("common.cancel"),
              type: "warning",
              beforeClose: (action, instance, done) => {
                count = true;
                done();
              }
            })
              .then(() => {
                router.push("/login");
              })
              .catch(() => {});
          }
        }
        break;
      default:
    }

    NProgress.done();
    return result;
  },
  error => {
    NProgress.done();
    if (error.code === "ECONNABORTED" || error.message.indexOf("timeout") !== -1) {
      Message.warning(i18n.t("api.rto"));
    } else {
      switch (error.response.status) {
        case 400:
          error.message = i18n.t("api.re");
          break;
        case 401:
          error.message = i18n.t("api.upl");
          break;
        case 403:
          error.message = i18n.t("api.ad");
          break;
        case 404:
          error.message = i18n.t("api.eir") + ":" + error.response.config.url;
          break;
        case 408:
          error.message = i18n.t("api.rto");
          break;
        case 500:
          error.message = i18n.t("api.ise");
          break;
        case 501:
          error.message = i18n.t("api.sini");
          break;
        case 503:
          error.message = i18n.t("api.sin");
          break;
        case 504:
          error.message = i18n.t("api.gt");
          break;
        case 505:
          error.message = i18n.t("api.vins");
          break;
        default:
      }
      Message.error(error.message);
    }
    return Promise.reject(error);
  }
);

export default function $axios(options) {
  return instance(options);
}
